import { ReactElement } from 'react'

import { AppLoader } from 'modules/app-registry/templates/FullPageAppTemplate/components/AppLoader'

interface State {
  isLoaded?: boolean
  isError?: boolean
}

export const getStateContent = (
  state: State,
  errorNode: ReactElement | null
) => {
  const { isLoaded, isError } = state
  if (!isLoaded) {
    return <AppLoader />
  }

  if (isError) {
    return errorNode
  }

  return null
}
